export default {"src":"/_next/static/media/notifications.01f6a364.svg","height":148,"width":282,"blurWidth":0,"blurHeight":0};